import styled from 'styled-components';

import { px } from 'theme';

export const Row = styled.div`
  display: flex;
  gap: 0.2rem;
`;

export const Star = styled.span<{ $filled: boolean; $size: number }>`
  font-size: ${({ $size }) => px($size)};
  color: ${({ $filled, theme }) =>
    $filled ? theme.colors.amber : theme.colors.border};
  line-height: 1;
`;
